export default function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}

export function getTimeElapsed(dateTimeString) {
  if (!dateTimeString) {
    return '';
  }

  const inputDate = new Date(dateTimeString);
  if (Number.isNaN(inputDate.getTime())) {
    return '';
  }

  const now = new Date();
  let diffInSeconds = Math.floor((now - inputDate) / 1000);

  const years = Math.floor(diffInSeconds / (365 * 24 * 60 * 60));
  diffInSeconds -= years * 365 * 24 * 60 * 60;

  const months = Math.floor(diffInSeconds / (30 * 24 * 60 * 60));
  diffInSeconds -= months * 30 * 24 * 60 * 60;

  const days = Math.floor(diffInSeconds / (24 * 60 * 60));
  diffInSeconds -= days * 24 * 60 * 60;

  const hours = Math.floor(diffInSeconds / (60 * 60));
  diffInSeconds -= hours * 60 * 60;

  const minutes = Math.floor(diffInSeconds / 60);
  const seconds = diffInSeconds % 60;

  const timeUnits = [
    { value: years, label: 'y' },
    { value: months, label: 'mo' },
    { value: days, label: 'd' },
    { value: hours, label: 'h' },
    { value: minutes, label: 'm' },
    { value: seconds, label: 's' },
  ];

  const parts = timeUnits
    .filter(unit => unit.value > 0)
    .slice(0, 2)
    .map(unit => `${unit.value}${unit.label}`);

  const result = parts.length > 0 ? parts.join(' ') : '0s';
  return `${result} ago`;
}
